import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, align = "left", testId }) => (
  <div className={align === "center" ? "text-center" : ""} data-testid={testId}>
    <Reveal>
      <p className="eyebrow mb-5">{eyebrow}</p>
    </Reveal>
    {title && (
      <Reveal delay={0.08}>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05] text-white">
          {title}
        </h2>
      </Reveal>
    )}
  </div>
);

export { EASE };
